import { createRoot } from "react-dom/client";

/**
 * Renders a React element in a new window and triggers print (print-to-PDF).
 * This is a print-template–based approach, not a headless PDF pipeline.
 */
export function exportPdf(element: React.ReactElement, title = "Print") {
  const printWindow = window.open("", "_blank", "width=900,height=700");
  if (!printWindow) return;

  // Copy stylesheets for print styling
  const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
    .map((el) => el.outerHTML)
    .join("\n");

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>${title}</title>
        ${styles}
        <style>
          @media print {
            body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          }
          body { background: white; color: #111; margin: 0; }
          .print-template { max-width: 8.5in; margin: 0 auto; }
        </style>
      </head>
      <body>
        <div id="print-root"></div>
      </body>
    </html>
  `);
  printWindow.document.close();

  const root = printWindow.document.getElementById("print-root");
  if (root) {
    const reactRoot = createRoot(root);
    reactRoot.render(element);

    // Wait for render then print
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
    }, 600);
  }
}

/**
 * Print a DOM element by cloning it into a new window.
 */
export function printElement(el: HTMLElement, title = "Print") {
  const printWindow = window.open("", "_blank", "width=900,height=700");
  if (!printWindow) return;

  const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
    .map((s) => s.outerHTML)
    .join("\n");

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head><title>${title}</title>${styles}
        <style>
          @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
          body { background: white; color: #111; margin: 0; padding: 24px; }
        </style>
      </head>
      <body>${el.outerHTML}</body>
    </html>
  `);
  printWindow.document.close();
  setTimeout(() => { printWindow.focus(); printWindow.print(); }, 400);
}
